import React, { FormEventHandler } from 'react';

import { Button, DialogActions, DialogContent } from '@mui/material';

import { CollectionReason } from '../../types';
import CaseIDAndReasons from '../Common/CaseIDAndReasons';

interface Props {
  reason: CollectionReason;
  onSubmit: FormEventHandler<HTMLFormElement>;
  decrementStep: () => void;
  defaultComment?: string;
  defaultCaseId: string;
}

export default function InsuranceBreakage({ reason, onSubmit, decrementStep, defaultComment, defaultCaseId }: Props) {
  return (
    <>
      <DialogContent dividers>
        <form onSubmit={onSubmit} id="insurance-breakage-form">
          <CaseIDAndReasons reason={reason} defaultComment={defaultComment} defaultCaseId={defaultCaseId} />
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={decrementStep}>Back</Button>
        <Button type="submit" variant="contained" form="insurance-breakage-form">
          Continue
        </Button>
      </DialogActions>
    </>
  );
}
